import {useState, useRef} from "react";

type SetStateAction<S> = S | ((prevState: S) => S);
/**
 * rc-utils.ts  & use-merge-value
 * value: =undefined 表示值不受控制，
 * 置空不要设置为undefined值， 应使用null
 *
 * @param defaultStateValue
 * @param option
 */
export default function useMergedState<T, R = T>(
  defaultStateValue: T | (() => T),
  option?: {
    defaultValue?: T | (() => T);
    value?: T;
    onChange?: (value: T, prevValue: T) => void;
    postState?: (value: T) => T;
  },
): [R, (value: SetStateAction<T>) => void] {
  const { defaultValue, value, onChange, postState } = option || {};
  const [innerValue, setInnerValue] = useState<T>(() => {
    if (value !== undefined) {
      return value;
    }
    if (defaultValue !== undefined) {
      return typeof defaultValue === 'function'
        ? (defaultValue as any)()
        : defaultValue;
    }
    return typeof defaultStateValue === 'function'
      ? (defaultStateValue as any)()
      : defaultStateValue;
  });

  let mergedValue = value !== undefined ? value : innerValue;
  if (postState) {
    mergedValue = postState(mergedValue);
  }

  const mergedValueRef = useRef<T>();
  mergedValueRef.current = mergedValue;
  function triggerChange(v: SetStateAction<T>) {
    const mergedValue = mergedValueRef.current!;
    let newValue: T;
    if (typeof v === 'function') {
      newValue = (v as any)(mergedValue);
    } else {
      newValue = v;
    }
    setInnerValue(newValue);
    if (mergedValue !== newValue && onChange) {
      onChange(newValue, mergedValue);
    }
  }

  //用undefined标识组件不受控制，而不是设置为undefined值， 重置值使用null
  // Effect of reset value to `undefined`  确保undefined也能重置
  // const firstRenderRef = React.useRef(true);
  // React.useEffect(() => {
  //   if (firstRenderRef.current) {
  //     firstRenderRef.current = false;
  //     return;
  //   }
  //
  //   if (value === undefined) {
  //     setInnerValue(value as any);
  //   }
  // }, [value]);

  return [mergedValue as unknown as R, triggerChange];
}
